<template>
  <div class="swap-order-detail">
    <div class="list">
      <div class="name-label">{{ $t('lang.Order number') }}</div>
      <div class="value-label">{{ orderNo }}</div>
      <div class="name-label">{{ $t('lang.Equipment number') }}</div>
      <div class="value-label">{{ primaryDeviceNo }}</div>
      <div class="name-label">{{ $t('lang.delivery address') }}</div>
      <div class="value-label">{{ address }}</div>
    </div>
    <div class="list">
      <div class="blue-btn" style="width: auto; padding: 0 10px" @click="onQueryBtnClick">
        {{ $t('lang.View equipment snapshot') }}
      </div>
      <div class="blue-btn ml10" style="width: auto; padding: 0 10px" @click="onQueryRecordClick">
        {{ $t('lang.View the sending request record') }}
      </div>
    </div>
    <el-steps class="step" direction="vertical" space="70px" :active="activeStep">
      <el-step
        :title="inPort + ' ' + $t('lang.Cabinet door') +(stepOne=='active' ? $t('lang.opened') : $t('lang.opening'))"></el-step>

      <span v-if="status=='dealing' && step=='0' && nextStepLeftTime>-1" class="left-time"
            style="top:136px"> {{ $t('lang.Remaining Completion Time') }} {{ nextStepLeftTime }} {{ $t('lang.sec') }}</span>
      <el-step :title="$t('lang.Put in the battery and close the cabinet door')"
               :description="$t('lang.Make sure the battery is plugged in')"></el-step>

      <span v-if="status=='dealing' && (step=='1' || step=='2') && nextStepLeftTime>-1" class="left-time"
            style="top:206px;left: 420px"> {{ $t('lang.Remaining Completion Time') }} {{ nextStepLeftTime }} {{ $t('lang.sec') }}</span>

      <el-step
        :title="outPort + ' ' + $t('lang.Cabinet door') +(stepFour=='active'? $t('lang.opened') : $t('lang.opening'))"></el-step>

      <span v-if="status=='dealing' && step=='3' && nextStepLeftTime>-1" class="left-time"
            style="top:276px"> {{ $t('lang.Remaining Completion Time') }} {{ nextStepLeftTime }} {{ $t('lang.sec') }}</span>

      <el-step :title="$t('lang.Please remove the battery and close the cabinet door')"></el-step>

      <span v-if="status=='dealing' && step=='4' && nextStepLeftTime>-1" class="left-time"
            style="top:346px;left: 485px"> {{ $t('lang.Remaining Completion Time') }} {{ nextStepLeftTime }} {{ $t('lang.sec') }}</span>
    </el-steps>
    <div class="list" style="margin-top: 0">
      <div class="red" v-if="status=='fail'">{{ failReason }}</div>
    </div>
    <div class="list">
      <div class="normal-btn fixed-width-125" style="width: auto; padding: 0 8px" @click="cancel"
           v-if="status=='success'||status=='fail'">
        {{ status == 'success' ? $t('lang.Successful, confirm return') : $t('lang.Failed, confirm return') }}
      </div>
    </div>
    <el-button type="primary" @click="cancelBtn">{{ $t('lang.back') }}</el-button>

  </div>
</template>
<script>
export default {
  name: 'batterySwapOrderProcessView',
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      orderNo: "",
      recordNo: "",
      status: "",
      inPort: "",
      outPort: "",
      step: "",
      activeStep: 0,
      stepOne: '',
      stepTwo: '',
      stepThree: '',
      stepFour: '',
      stepFive: '',
      primaryDeviceNo: "",
      location: "",
      nextStepLeftTime: "",
      operateAbleChargePortSeqNo: "-1",
      failReason: "",
      queryResultInterval: null,
      address: ""
    }
  },
  watch: {
    editData: {
      handler() {

      },
      deep: true,
    },
  },
  mounted() {
    console.log(this.editData, 'editData22222');
    this.recordNo = this.editData.recordNo;
    this.address = this.editData.address;
    this.queryBatterySwapRecordStep();
    let self = this;
    this.queryResultInterval = setInterval(self.queryBatterySwapRecordStep, 1000)
  },
  destroyed() {
    this.clearQueryResultInterval();
  },
  methods: {
    cancelBtn() {
      this.$emit('cancel');
    },
    queryBatterySwapRecordStep() {
      let self = this;
      let params = {
        recordNo: this.recordNo
      };
      this.$http.post('/electricity/queryBatterySwapRecordStep', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || self.$t('lang.Query failed'),
            center: true
          });
          return;
        }
        let status = res.mdata.status;
        let step = res.mdata.step;
        let nextStepLeftTime = res.mdata.nextStepLeftTime || -1;
        let operateAbleChargePortSeqNo = res.mdata.operateAbleChargePortSeqNo;
        let failReason = res.mdata.failReason || "";
        self.orderNo = res.mdata.orderNo;
        self.primaryDeviceNo = res.mdata.primaryDeviceNo;
        self.status = status;
        self.step = step;
        self.nextStepLeftTime = nextStepLeftTime;
        self.inPort = res.mdata.inPortSeqNo;
        self.outPort = res.mdata.outPortSeqNo;
        self.failReason = failReason;
        self.operateAbleChargePortSeqNo = operateAbleChargePortSeqNo;
        if (res.mdata.terminate) {
          self.clearQueryResultInterval();
        }
        if (step == 1) {
          self.stepOne = 'active';
          self.activeStep = 1;
        } else if (step == 2) {
          self.stepOne = 'active';
          self.stepTwo = 'active';
          self.activeStep = 2;
        } else if (step == 3) {
          self.stepOne = 'active';
          self.stepTwo = 'active';
          self.stepThree = 'active'
        } else if (step == 4) {
          self.stepOne = 'active';
          self.stepTwo = 'active';
          self.stepThree = 'active';
          self.stepFour = 'active'
          self.activeStep = 3;
        } else if (step == 5) {
          self.stepOne = 'active';
          self.stepTwo = 'active';
          self.stepThree = 'active';
          self.stepFour = 'active';
          self.stepFive = 'active';
          self.activeStep = 4;
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    clearQueryResultInterval: function () {
      this.queryResultInterval && clearInterval(this.queryResultInterval);
      this.queryResultInterval = null;
    },
    cancel() {
      this.$emit('cancel');
    },
    // 跳转快照
    onQueryBtnClick() {
      this.$router.push({
        path: "/managePage/snapShot",
        query: {
          primaryDeviceNo: this.primaryDeviceNo
        }
      });
    },
    // 跳转发送请求记录
    onQueryRecordClick() {
      this.$router.push({
        path: "/managePage/sendRecord",
        query: {
          primaryDeviceNo: this.primaryDeviceNo
        }
      });
      // this.$router.push("/managePage/sendRecord?recordNo=" + this.recordNo + "&orderNo=" + this.orderNo);
    },
  },
}
</script>
<style lang="scss" scoped>
.main-body {
  min-height: 50px;
}

.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }

  .fixed-width-125 {
    width: 125px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.step {
  padding: 20px 30px;

  .left-time {
    position: absolute;
    left: 250px;
    color: red;
  }
}

.red {
  color: red;
}

.ml-40 {
  margin-left: 40px;
}

.bbn {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/batterySwapOrderProcessView.vue